<template>
  <div id="top-nav">
    <div class="header-container">
      <div class="header-left">
        <!-- 控制左侧菜单展示状态 -->
        <!-- <img src="@/assets/images/collapse.png" class="fold-btn" @click="toggleCollapse" alt=""> -->
        <!-- <i class="el-icon-s-unfold fold-btn" v-if="isCollapse" @click="toggleCollapse"></i> -->
        <img class="fold-btn" v-if="isCollapse" @click="toggleCollapse" src="https://s3.ap-malaysia-1.jdcloud-oss.com/jd-th-055-01-fop-source-static/iwms/el-icon-s-unfold.png" alt="" clstag="h|keycount|topMenu|toggleCollapse">
        <img class="fold-btn" v-else @click="toggleCollapse" src="https://s3.ap-malaysia-1.jdcloud-oss.com/jd-th-055-01-fop-source-static/iwms/el-icon-s-fold.png" alt="" clstag="h|keycount|topMenu|toggleCollapse">
        <!-- <i class="el-icon-s-fold fold-btn" v-else @click="toggleCollapse"></i> -->
        <!-- 系统LOGO 中英文 -->
        <img class="iwms-logo en-logo" src="https://s3.ap-malaysia-1.jdcloud-oss.com/jd-th-055-01-fop-source-static/iwms/LOGO-iWMS-e.png" alt="">
      </div>
      <i v-show="isScroll" class="el-icon-arrow-left" @click="leftSlide" clstag="h|keycount|topMenu|leftSlide"></i>
      <!-- ---------------中间一级菜单部分----------- -->
      <div class="header-center" ref="wrapperCon">
        <div
          class="top-menu-item"
          @click="handleSelectTopMenu(menu)"
          :class="{'menu-active': topIndex === menu.topIndex }"
          :clstag="getTopMenuClstag(menu)"
          v-for="menu of menuTree" :key="menu.id">
          <template v-if="menu.code !== 'globalBtnPermission'">
            <ToolTips effect="dark" :text="menu.translation ? $t(menu.translation) : menu.name" placement="bottom" style="text-align: center;">
              {{ menu.translation ? $t(menu.translation) : menu.name }}
            </ToolTips>
          </template>
        </div>
      </div>
       <i v-show="isScroll" class="el-icon-arrow-right" @click="rightSlide" clstag="h|keycount|topMenu|rightSlide"></i>
      <div class="header-right">
        <!-- <el-switch v-model="debugIsOn" @change="switchDebug"></el-switch> -->
        <div class="platformBtn" v-if="showTogglePlatform">
          <el-button type="primary" round @click="toPlatform" clstag="h|keycount|topMenu|toPlatform">
            <i class="i-toggle" />
          {{ $t('adminDashboard') }}
          </el-button>
        </div>
        <!-- 提报信息，仓储机器人，联系我们等 -->
        <el-popover
          placement="bottom"
          width="280"
          :visible-arrow="false"
          popper-class="top-nav-package-popper"
          trigger="hover">
          <div class="title">
            <img src="@/assets/images/newMenus/doc.png" alt="">{{ $t('submitInfo') }}
          </div>
          <div class="op-list">
            <!-- <div class="op-item">{{ $t('operationLogs') }}</div> -->
            <div class="op-item" @click="openWorkOrder" clstag="h|keycount|topMenu|openWorkOrder">{{ $t('itWorkOrder') }}</div>
          </div>
          <div class="title">
            <img src="@/assets/images/newMenus/robot.png" alt="">{{ $t('warehouseRobot') }}
          </div>
          <div class="op-list">
            <div class="op-item" @click="openRobot('app.upnjdfhh')" clstag="h|keycount|topMenu|openRobot">{{ $t('warehouseRobot') }}</div>
          </div>
          <div class="title">
            <img src="@/assets/images/newMenus/chat.png" alt="">{{ $t('contactUs') }}
          </div>
          <ul class="contact-list">
            <li class="list-item" v-for="item of contactList" :key="item.value">
              <span class="label">{{ $t(item.label) }}: </span>
              <span class="value" @click="openDongDong(item.value, '2')" clstag="h|keycount|topMenu|openDongDong"><img src="@/assets/images/newMenus/dongdong.png" alt="">{{ item.value }}</span>
            </li>
          </ul>

          <img src="@/assets/images/newMenus/package.png" alt="" class="package-icon" slot="reference">
        </el-popover>

        <!-- 下载 -->
        <el-popover
          placement="bottom"
          width="400"
          :visible-arrow="false"
          popper-class="top-nav-download-popper"
          trigger="hover">
          <!-- <h2>iWMS</h2> -->
          <!-- <p class="download-text"></p> -->
          <p class="bottom-text">
            <img src="@/assets/images/newMenus/doc.png" alt="">
            <span>
              <span class="title">{{ $t('downloadAndroidTitle') }}</span>
            </span>
          </p>
          <p class="bottom-text" style="padding-top: 0;display: inline-block;text-align: left;">
            {{ $t('downloadAppTips1') }}<span class="color-blue"  @click="openRobot('app.upnjdfhh')" clstag="h|keycount|topMenu|openRobotFromDownload"> {{ $t('downloadAppTips2') }}</span>
          </p>
          <div class="qrcode-container">
            <img :src="downloadImg" alt="">
          </div>
          <div class="other-wrap">
            <p class="title-wrap">
              <img src="@/assets/images/newMenus/doc.png" alt="">
              <span class="title">{{ $t('otherDownload') }}</span>
            </p>
            <div class="other-content">
              <span>{{ $t('cloudPrintingAssistant') }}：</span> <a href="https://s3.ap-malaysia-1.jdcloud-oss.com/jd-th-053-01-imp/PrintAgent-EN-2.1.1.4.exe" target="_blank" rel="noopener noreferrer">{{ $t('clickDownload') }}</a>
            </div>
          </div>

          <img src="@/assets/images/newMenus/download.png" v-if="site" alt="" class="download-icon" slot="reference">
        </el-popover>
        <msg-box v-if="isErpLogin" :userNo="userInfo.userCode" channel="iWMS" :boxPosition="{'top': 50,'right': -40}"></msg-box>

        <!-- 语言 -->
        <el-dropdown @command="handleCommandLang" size="small">
          <span class="el-dropdown-link">
            <div class="el-dropdown-user">
              <span>{{ langMaps[$i18n.locale] }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </div>
          </span>
          <el-dropdown-menu slot="dropdown" class="lang-dropdown">
            <el-dropdown-item :class="{'current-lang': $i18n.locale === key}" :command="key" v-for="(lang, key) of langMaps" :key="lang" :clstag="langClick(key)">{{ lang }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- 站点 -->
        <el-dropdown v-if="isJDDomain" class="dropdown-box jdc-container" @command="changeSite">
        <span class="el-dropdown-link">
          <span class="el-dropdown-link">
            <div class="el-dropdown-user">
              <span>{{ siteName }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </div>
          </span>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="SG" clstag="h|keycount|topMenu|changeSite|SG">{{ $t('siteMapSG') }}</el-dropdown-item>
          <el-dropdown-item command="EU" clstag="h|keycount|topMenu|changeSite|EU">{{ $t('siteMapEU') }}</el-dropdown-item>
          <el-dropdown-item command="US" clstag="h|keycount|topMenu|changeSite|US">{{ $t('siteMapUS') }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

        <!-- 头像及退出 -->
        <el-dropdown @command="handleCommand" size="small">
          <span class="el-dropdown-link">
            <div class="el-dropdown-user">
              <img class="dropdown-avatar" src="@/assets/images/default_avatar.png" alt="photo">
              <i class="el-icon-arrow-down"></i>
            </div>
          </span>
          <el-dropdown-menu slot="dropdown" class="user-dropdown">
            <p class="user-name">Hi, <span>{{ userInfo.userName }}</span></p>
            <!-- <div id="net_monitor_div"></div> -->
            <el-dropdown-item command="copyUserCode" icon="el-icon-document-copy" clstag="h|keycount|topMenu|copyUserCode">
              {{ userInfo.userCode  }}
            </el-dropdown-item>
            <el-dropdown-item command="selectWearhouse" icon="el-icon-house" clstag="h|keycount|topMenu|selectWarehouse">
              {{ currentWarehouse  }}
            </el-dropdown-item>
            <el-dropdown-item command="switchDebug" icon="el-icon-edit" v-if="hasOnlineCorrectionPermission" clstag="h|keycount|topMenu|switchDebug">
              {{ debugIsOn?$t('关闭在线纠错'): $t('开启在线纠错') }}
            </el-dropdown-item>
            <div class="divider"></div>
            <el-dropdown-item command="logout" icon="el-icon-switch-button" clstag="h|keycount|topMenu|logout"> {{ $t('signOut') }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div id="lang-box"></div>
    </div>
    <!-- 非navbar内容 -->
    <div id ="barcodeWrapper" style="visibility: hidden">
      <img id="barcode" />
    </div>
    <canvas width="500" height="200" ref="canvasCountry" id="canvasCountry" style="visibility: hidden"/>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { userInfo, domain } from '@/global'
import * as localStorage from '@/api/utils/storage/localStorage'
import ToolTips from './components/ToolTips.vue'
import {checkFromParameter, getBtnPermission} from '@/utils/setMethods.js'
import msgBox from '../msgBox.vue'

export default {
  name: 'topNav',
  components: {
    ToolTips,
    msgBox
  },
  data () {
    return {
      userInfo: userInfo,
      langMaps: {
        'zh_CN': '简体中文',
        'en_US': 'English',
        'pt_PT': 'Português',
        'fr_FR': 'Français',
        'de_DE': 'Deutsch',
        'es_ES': 'Espanol',
        'ja_JP': '日本語',
        'ko_KO': '한국어',
        'vi_VI': 'Tiếng Việt',
        'id_ID': 'Bahasa Indonesia',
        'tr_TR': 'Türkçe',
        'it_IT': 'Italiano',
      },
      site: Cookies.get('lwms.env') || 'test',
      contactList: [
        {
          label: 'dutySupport',
          value: '80868478'
        }
      ],
      siteCode: 'SG',
      menuWidth: 0,
      contentWidth: 0,
      debugIsOn:false,
      correctPinList:[],
      i18nFlag:localStorage.getLocalStorgeValue('i18nFlag') || 'false',
      visible: true,
      hasOnlineCorrectionPermission: false
    }
  },
  props: {
    menuTree: {
      type: Array,
      defaul() {
        return {}
      }
    }
  },
  computed: {
    isCollapse(){
      return this.$store.state.mutations.isCollapse
    },
    // 当前仓
    currentWarehouse() {
      return Cookies.get('login.select.warehouse') || Cookies.get('warehouseNo')
    },
    // 顶部index
    topIndex() {
      return this.$store.state.appStore.currentTopIndex
    },
    menuRouterLinks() {
      return this.$store.state.appStore.menuRouterLinks
    },
    currentSideMenus() {
      return this.menuRouterLinks[this.topIndex]
    },
    menuRouterIndex(){
      return this.$store.state.appStore.menuRouterIndex
    },
    downloadImg() {
      if(this.site === 'hk' || this.site === 'hk.uat') { // 新加坡
        return 'https://img11.360buyimg.com/imagetools/jfs/t1/224422/32/5592/14409/656ed778Fae25da31/30b93470e9db180f.png'
      } else if(this.site === 'hl' || this.site === 'hl.uat') { // 荷兰
        return 'https://img13.360buyimg.com/imagetools/jfs/t1/237544/7/6103/14398/656ed778F84f23a71/6cb512b0583fd3d4.png'
      } else if(this.site === 'gg' || this.site === 'gg.uat') { // 谷歌
        return 'https://img10.360buyimg.com/imagetools/jfs/t1/230609/10/5777/14536/656ed778F891cc0be/1742197eef37af02.png'
      } else {
        return ''
      }
    },
    siteName() {
      let siteMap = {
        SG: this.$t('siteMapSG'),
        EU: this.$t('siteMapEU'),
        US: this.$t('siteMapUS')
      }
      return siteMap[this.siteCode]
    },
    isJDDomain() {
      const hostname = window.location.hostname;
      const isJDDomain = hostname.endsWith('.jd.com') && window.location.host === 'iwms.jd.com';
      return isJDDomain
    },
    showTogglePlatform(){
      const queryString = window.location.href;
      return Cookies.get('lwms.lt')==='erp' && checkFromParameter(queryString,'platform')
    },
    isErpLogin(){
      return Cookies.get('lwms.lt')==='erp' && userInfo && userInfo.userCode
    },
    isScroll() {
      if(this.contentWidth > this.menuWidth) {
        return true
      } else {
        return false
      }
    },
  },
  methods: {
    switchDebug(){
      if(this.debugIsOn){
        window.langBoxObj&&window.langBoxObj.debugSwitchOffCallBack()
      }else{
        window.langBoxObj&&window.langBoxObj.debugSwitchOnCallBack()
      }
      this.debugIsOn=!this.debugIsOn
    },
    isMcaSite() {
      let mcaSwitch = window.localStorage.getItem('SET_MCA_SWITCH');
      return mcaSwitch === 'true';
    },
    toPlatform(){
      window.open('https://iwms-mp.jd.com/', '_blank')
    },
    toggleCollapse () {
      this.$store.commit('COLLAPSE_ALL_SIDE', false)
      this.$store.dispatch('toggleCollapse')
    },
    // 退出及其他功能
    handleCommand(command){
      if (command === 'logout') {
        this.logout()
      }
      // 选择仓库跳转
      if (command === 'selectWearhouse') {
        this.$router.push({ path: '/selectWarehouse' })
      }
      if (command === 'switchDebug') {
        this.switchDebug()
      }
      if (command === 'copyUserCode'){
        this.copyToClipboard(this.userInfo.userCode);
      }
    },
    // 切换语言
    handleCommandLang(command){
      this.changeLanguage(command)
    },
    copyToClipboard(text) {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        this.$notify.success(this.$t('copySucess'));
      } catch (err) {
        this.$notify.error(this.$t('copyFalied'));
      }
      document.body.removeChild(textarea);
    },
    logout() {
      this.removeLocalMenResource();
      const relanchPath = window.location.href.indexOf('unauthorized') > -1 ? window.location.href.replace('unauthorized', 'index') : window.location.href
      const url = `${Cookies.get('lwms.logout.url')}?ReturnUrl=${encodeURIComponent(relanchPath)}&bLoginType=${Cookies.get('lwms.lt') ? Cookies.get('lwms.lt') : 'b'}`
      window.location.href = url
    },
    removeLocalMenResource() {
      localStorage.removeLocalStorageValue(`lwmsLoginUserSpmMenuTreeNew-${this.userInfo.userName}-${this.userInfo.warehouseNo}`)
      localStorage.removeLocalStorageValue(`lwmsLoginUserWmsMenuTreeNew-${this.userInfo.userName}`)
      localStorage.removeLocalStorageValue('menuRouterLinks')
      localStorage.removeLocalStorageValue('commonMenus')
    },
    changeLanguage(language){
      this.$i18n.locale = language
      Cookies.set('jd.erp.lang', language)
      Cookies.set('jd.erp.lang', language, { domain: domain() })
      window.langBoxObj && window.langBoxObj.changeLangInDebugCallBack()
      window.reInitAIAssistantSDK()
    },
    getFirstLeafNode(tree) {
      if (tree.children && tree.children.length > 0) {
        for (let i = 0; i < tree.children.length; i++) {
          const leafNode = this.getFirstLeafNode(tree.children[i]);
          if (leafNode) {
            return leafNode;
          }
        }
      } else {
        return tree;
      }
    },
    handleSelectTopMenu(item) {
      this.$store.commit('COLLAPSE_ALL_SIDE',false)
      this.$store.commit('setCollapse', false)
      this.$store.commit('SET_MENU_ROUTER_INDEX',true)
      console.log(item.topIndex,this.menuRouterIndex);
      this.$store.commit('SET_TOP_INDEX', item.topIndex)
      this.getFirstLeafNode(this.currentSideMenus)
      // this.$router.push(topPath.url)
      // const topPath = this.getFirstLeafNode(this.currentSideMenus)
      // console.log(topPath)
      // this.$router.push(topPath.url)
    },
    // 打开京me type = 2 是打开群，不传type是打开联系人
    openDongDong(erp, type) {
      window.location.href = `timline://chat?topin=${erp}&type=${type}`;
    },
    // 打开京me 机器人
    openRobot (erp) {
      window.location.href = `timline://chat?topin=${erp}&appid=robot.dd`;
    },
    // 打开工单
    openWorkOrder() {
      // 跳转到对应的工单页面并且切换成对应语言
      let languageObj = {
        'zh_CN': 'zh',
        'en_US': 'en',
        'pt_PT': 'po',
        'fr_FR': 'fr',
        'de_DE': 'ge',
        'es_ES': 'es',
        'ja_JP': 'ja',
        'ko_KO': 'ko',
        'vi_VI': 'vi'
      }
      let language = languageObj[this.$i18n.locale] ? languageObj[this.$i18n.locale] : 'zh';
      window.open(`http://it.jd.com/submit?level=3&number=245095633093888&language=${language}`, '_blank');
    },
    langClick(lang) {
      return "h|keycount|topMenu|language|" + lang
    },
    getTopMenuClstag(menu) {
      if (menu.code === 'globalBtnPermission') {
        return ''
      }
      // 使用菜单的code或translation作为埋点key的一部分
      const menuKey = menu.code || menu.translation || menu.name || 'unknown'
      return `h|keycount|topMenu|${menuKey}`
    },
    changeSite(val) {
      const valMap = {
        'SG': 'SG',
        'EU': 'EU',
        'US': 'US',
      }
      this.siteCode = valMap[val]
      Cookies.set('x-cdn-client-country-code', this.siteCode)
      window.location.reload()
    },
    initMenuWidth() {
      const that = this
      setTimeout(() => {
        //获取菜单外层宽度
        const navbarTopMenu = document.querySelector('.header-center');
        const navbarWidth = navbarTopMenu.offsetWidth;
        that.menuWidth = navbarWidth
        const menuItems = document.querySelectorAll('.top-menu-item');
        //计算菜单内容宽度
        let totalWidth = 0;
        menuItems.forEach(function(item) {
          const itemWidth = item.offsetWidth;
          totalWidth += itemWidth;
          that.contentWidth = totalWidth
        })
      }, 200)
      window.addEventListener('resize', function() {
        //获取菜单外层宽度
        const navbarTopMenu = document.querySelector('.header-center');
        const navbarWidth = navbarTopMenu.offsetWidth;
        that.menuWidth = navbarWidth
        const menuItems = document.querySelectorAll('.top-menu-item');
        //计算菜单内容宽度
        let totalWidth = 0;
        menuItems.forEach(function(item) {
          const itemWidth = item.offsetWidth;
          totalWidth += itemWidth;
          that.contentWidth = totalWidth
        })
      });
    },
    leftSlide(){
      // 保存滚动盒子左侧已滚动的距离
      let left=this.$refs.wrapperCon.scrollLeft
      let num=0
      clearInterval(this.timer)
      this.timer=null
      this.timer=setInterval(()=>{
        //   !left:已经滚动到最左侧
        //   一次性滚动距离（可调节）
        if(!left||num>=300){
          // 停止滚动
          clearInterval(this.timer)
          this.timer=null
          return
        }
        // 给滚动盒子元素赋值向左滚动距离
        this.$refs.wrapperCon.scrollLeft=left-=30
        // 保存向左滚动距离（方便判断一次性滚动多少距离）
        num+=30
      },20)
      // 20：速度（可调节）
    },
    rightSlide(){
      // 保存滚动盒子左侧已滚动的距离
      let left=this.$refs.wrapperCon.scrollLeft
      // 保存元素的整体宽度
      let scrollWidth=this.$refs.wrapperCon.scrollWidth
      // 保存元素的可见宽度
      let clientWidth=this.$refs.wrapperCon.clientWidth
      let num=0
      clearInterval(this.timer)
      this.timer=setInterval(()=>{
        // 已经滚动距离+可见宽度
        // left+clientWidth>=scrollWidth：滚动到最右侧
        // num>=300一次性滚动距离
        if(left+clientWidth>=scrollWidth||num>=300){
          clearInterval(this.timer)
          return
        }
        // 给滚动盒子元素赋值向左滚动距离
        this.$refs.wrapperCon.scrollLeft=left+=30
        // 保存向左滚动距离（方便判断一次性滚动多少距离）
        num+=30
      },20)
      // 20：速度（可调节）
    },
  },
  async created() {
    if(Cookies.get('x-cdn-client-country-code')) {
      this.siteCode = Cookies.get('x-cdn-client-country-code')
    } else {
      this.siteCode = 'SG'
    }
    this.initMenuWidth()
    try {
      this.hasOnlineCorrectionPermission = getBtnPermission('Online-Correction')
    } catch (error) {
      this.hasOnlineCorrectionPermission = false
      console.log(error)
    }
  }
}
</script>

<style lang="scss" scoped>
$mainColor: #3C6EF0;
$fontColor: #525765;
@mixin flex {
  display: flex;
  align-items: center;
}
#top-nav{
  height: 64px;
  background-color: #FFF;
  padding: 0 32px 0 8px;
  box-sizing: border-box;
  border-bottom: 1px solid #F1F2F4;
  color: $fontColor;
  .header-container{
    width: 100%;
    height: 100%;
    @include flex;
    justify-content: space-between;
    .header-left{
      @include flex;
      margin-right: 28px;
      .iwms-logo{
        display:inline-block;
        width: 172px;
        height: 32px;
      }
      .fold-btn{
        margin-right: 12px;
        width: 24px;
        height: 24px;
        // font-size: 24px;
        // color: #525765;
      }
      #net_monitor_div{
        min-width: 250px;
        white-space: nowrap;
        overflow: unset !important;
        height: auto !important;
        top: 0 !important;
        /deep/ p{
          position: unset !important;
          bottom: unset !important;
        }
      }
    }
    .header-center {
      flex: 1;
      @include flex;
      align-items: center;
      overflow-x: scroll;
      &::-webkit-scrollbar {
        display: none; // 隐藏滚动条
      }
      .top-menu-item {
        height: 64px;
        line-height: 64px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: normal;
        color: #525765;
        padding: 0 12px;
        cursor: pointer;
        font-weight: bold;
        white-space: nowrap;
        // max-width: 100px;
        // min-width: 70px;
        // overflow: hidden;
        // text-overflow: ellipsis;
        &.menu-active {
          color: #3C6EF0;
          position: relative;
          &::after {
            content: '';
            width: 16px;
            height: 4px;
            background: #3C6EF0;
            border-radius: 2px;
            position: absolute;
            bottom: 2px;
            left: 50%;
            margin-left: -8px;
          }
        }
      }
    }
    .el-icon-arrow-left{
      display: flex;
      align-items: center;
      color: #525765;
      cursor: pointer;
      font-weight: 600;
    }
    .el-icon-arrow-right{
      display: flex;
      align-items: center;
      color: #525765;
      cursor: pointer;
      font-weight: 600;
    }
    .header-right {
      @include flex;
      align-items: center;
      .package-icon, .download-icon {
        width: 16px;
        height: 16px;
        margin: 3px 8px 0;
        cursor: pointer;

      }
      .el-dropdown{
        margin-left: 18px;
        font-size: 14px;
        cursor: pointer;
        .el-dropdown-user {
          @include flex;
          align-items: center;
          flex-wrap: nowrap;
          >span {
            white-space:nowrap;
          }
          .dropdown-avatar{
            width: 32px;
            height: 32px;
            margin-right: 8px;
          }
        }
        .el-icon-arrow-down {
          font-size: 16px;
          font-weight: bold;
        }
      }
      .version-container {
        padding: 6px 8px;
        display: flex;
        align-items: center;
        cursor: pointer;
        .version-icon {
          width: 16px;
          height: 16px;
          display: inline-block;
          margin-right: 4px;
          background: url("~@/assets/images/newMenus/change_to_old.png") no-repeat;
          background-size: 100% 100%;
        }
        .version-text {
          height: 20px;
          line-height: 20px;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: normal;
          white-space: nowrap;
        }

      }
    }
  }
}
.user-dropdown {
  left: auto !important;;
  right: 18px;
  min-width: 172px;
  top: 60px !important;
  padding: 12px 8px;
  p {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 600;
    color: rgba(35,37,43,1);
    text-align: center;
  }
  .divider {
    width: 100%;
    height: 1px;
    background: #F7F7F9;
    margin: 2px 0;
  }
  .el-dropdown-menu__item {
    height: 40px;
    line-height: 40px;
    border-radius: 8px;
    font-size: 14px;
    color: $fontColor;
    &:hover {
      background: #F5F5F6;
    }
  }
  /deep/ .popper__arrow {
    display: none !important;
  }
}
.lang-dropdown {
  min-width: 180px;
  top: 60px !important;
  padding: 4px;
  .el-dropdown-menu__item {
    height: 40px;
    line-height: 40px;
    border-radius: 8px;
    font-size: 14px;
    color: $fontColor;
    &:hover {
      background: #F5F5F6;
    }
    &.current-lang {
      color: $mainColor;
      background: rgba($color: $mainColor, $alpha: 0.1);
    }
  }
  /deep/ .popper__arrow {
    display: none !important;
  }
}
.i-toggle {
  display: inline-block;
  width: 12px;
  height: 10px;
  margin-right: 3px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAKCAYAAACALL/6AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAADKADAAQAAAABAAAACgAAAACcTA/9AAAAhklEQVQYGWNgQAL///+vBWJpJCHsTKAiNiCeB8T7gJgRuyqIKAtQAQ+QuRWIXwJxDBALA8WAFFbwmxEoOREoFQ/EH7EqQRU8hcqlBQ/kpHagwVFEGM4NVHMZpAHkaQ4CGsqA8t5A7EhAHQMD0MBpQLwbiIVAilkI6mBgYAWq8WZkZPwFUgsAPCQ3IS7UGMEAAAAASUVORK5CYII=) no-repeat;
  overflow: hidden;
  vertical-align: middle;
}
.platformBtn{
  .el-button{
    line-height: 0 !important;
  }
}
</style>
<style lang="scss">
.top-nav-download-popper {
  padding: 16px 16px 0 !important;
  margin-top: 30px !important;
  border-radius: 8px;
  h2 {
    margin: 0;
    line-height: 20px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 600;
    color: rgba(82,87,101,1);
    text-align: center;
  }
  .qrcode-container {
    text-align: center;
    background-color: #F5F5F6;
    padding: 10px;
    border-radius: 8px;
    img {
      width: 86px;
      height: 86px;
      border: 5px solid #E4E5E9;
      border-radius: 8px;
    }
  }
  .download-text {
    line-height: 18px;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: normal;
    color: #525765;
    text-align: center;
  }
  .bottom-text {
    display: flex;
    align-items: flex-start;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: normal;
    color: #525765;
    text-align: center;
    padding: 11px 0;
    margin: 0px 0 0;
    /* border-top: 1px solid #E4E5E9; */
    .color-blue {
      color: #3C6EF0;
    }
    img{
      width: 16px;
      height: 16px;
      margin-right: 5px;
    }
    .title{
      font-weight: 600;
      color: #525765;
    }
  }
  .other-wrap{
    .title-wrap{
      display: flex;
      align-items: center;
      .title{
        font-size: 14px;
        font-weight: 600;
        color: #525765;
      }
      img{
        width: 16px;
        height: 16px;
        margin-right: 5px;
      }
    }
    .other-content{
      padding: 0 18px 10px;
      a{
        color: #3C6EF0;
        text-decoration: none;
        cursor: pointer;
      }
    }
  }
}
.top-nav-package-popper {
  padding: 16px 16px 0;
  margin-top: 30px !important;
  border-radius: 8px;
  .title {
    display: flex;
    align-items: center;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 600;
    color: rgba(82,87,101,1);
    img {
      width: 16px;
      height: 16px;
      margin-right: 6px;
    }

  }
  .op-list {
    margin-top: 16px;
    margin-bottom: 24px;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    .op-item {
      min-width: 190px;
      height: 32px;
      line-height: 32px;
      background: rgba(245,245,246,1);
      border-radius: 8px;
      text-align: center;
      color: #23252B;
      padding: 0 12px;
      cursor: pointer;
      &:hover {
        background: rgba(60,110,240,0.1);
        color: #3C6EF0;
      }
    }
  }
  .contact-list {
    margin-top: 12px;
    font-size: 14px;
    padding: 0;
    .list-item {
      display: flex;
      height: 20px;
      line-height: 20px;
      padding: 6px 12px;
      border-radius: 8px;
      align-items: center;
      .label {
        margin-right: 12px;
      }
      .value {
        color: #3C6EF0;
        display: flex;
        align-items: center;
        img {
          width: 16px;
          height: 16px;
          margin-right: 4px;
        }
      }
      &:hover {
        background: #F5F5F6;
      }
    }
  }
}
</style>
